import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
import Stack from 'components/Stack';
import Text from 'components/Text';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DeleteEmailConfirmationModal(_ref) {
  var emailId = _ref.emailId,
    email = _ref.email,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    isPending = _ref.isPending,
    description = _ref.description;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(SimpleModal, {
    title: t('modal_delete_additional_email_title'),
    body: /*#__PURE__*/_jsxs(Stack, {
      spacing: "s",
      children: [/*#__PURE__*/_jsx(Text, {
        children: description
      }), /*#__PURE__*/_jsx(Text, {
        bold: true,
        children: email
      })]
    }),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onClose,
      isDisabled: isPending
    }, {
      label: t('actions_delete'),
      variant: 'important',
      isLoading: isPending,
      onClick: function () {
        var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return onConfirm(emailId);
              case 1:
                onClose();
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onClick() {
          return _onClick.apply(this, arguments);
        }
        return onClick;
      }()
    }],
    onClose: onClose
  });
}
export default DeleteEmailConfirmationModal;